module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('setting-title', {
    attrs: {
      "title": "用户管理"
    }
  }), _c('div', {
    staticClass: "iframe-header"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": "账户信息"
    },
    slot: "icon"
  })], 1), _c('iframe', {
    attrs: {
      "src": "https://registry.dmp.360.cn/user",
      "frameborder": "0",
      "width": "100%",
      "height": "100%",
      "scrolling": "no"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f3a3382", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f3a3382!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/account.vue
// module id = 710
// module chunks = 0